/**
 * Application Constants
 * 
 * Centralized location for all application-wide constants.
 * Modify these values to update links and configuration across the entire application.
 */

/**
 * Discord Community Link
 * This is the single source of truth for the Discord invite link.
 * All Discord links throughout the application reference this constant.
 */
export const DISCORD_LINK = "https://discord.com/invite/ScRsc9NKPT";

/**
 * Twitter/X Handle
 * The official Twitter handle for PeopleTag.
 */
export const TWITTER_HANDLE = "@peopletaginc";

/**
 * Twitter/X Profile URL
 * The official Twitter profile URL for PeopleTag.
 */
export const TWITTER_URL = "https://x.com/peopletaginc";

/**
 * PeopleTag App URL
 * The main application URL for PeopleTag.
 */
export const APP_URL = 'https://peopletag.xyz';

